import React, { useCallback, useState } from 'react'
import { BqIcon, BqOption } from '@beeq/react'
import { Text } from '../../../constants/TextConstants'
import { useSave } from '../../../Context/saveContext'
import { PERMISSION_CODES } from '../../../constants/permissions'
import PropTypes from 'prop-types'
import { isAdminRole } from '../../../utils/utils'
import { Link } from 'react-router-dom'
import { ConfirmProfileDeletionDialog } from './ConfirmProfileDeletionDialog'
import { ExportProfile } from '../../Modals/ExportProfile'
import { ActionsMenu } from '../../../components/Base/ActionsMenu'

export const ActionsCell = ({ userEmail, setIsLoading, setLoadingText, getProfiles, filtersToRequest, advancedSearchFilterData }) => {
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
  const toggleDeleteModalOpen = () => {
    setIsOpenDeleteModal((prev) => !prev)
  }

  const [isOpenExportModal, setIsOpenExportModal] = useState(false)
  const toggleExportModalOpen = () => {
    setIsOpenExportModal((prev) => !prev)
  }
  const { userProfile, userPermissions, permissionsQuantity } = useSave()
  const userFullname = userEmail.split('@')[0].toLowerCase()

  const isAllowedToViewProfile = userPermissions.includes(PERMISSION_CODES.viewProfile.code)

  const isAdminProfileRow = userEmail === userProfile?.email
  const isAllowedToDeleteViewProfile =
    userProfile?.userRole &&
    isAdminRole(userProfile.userRole, userPermissions.length, permissionsQuantity) &&
    !isAdminProfileRow

  const isAllowedToExportProfile = userPermissions.includes(PERMISSION_CODES.exportProfiles.code)

  const copyUserUrlHandler = useCallback(async () => {
    try {
      const userUrl = `${window.location.origin}/view/${userFullname}`
      await navigator.clipboard.writeText(userUrl)
    } catch (e) {
      console.error('Failed to copy: ', e)
    }
  }, [userEmail])

  return (
    <>
      <ActionsMenu panelHeight={152} placement='bottom-end'>
        <React.Fragment>
          {isAllowedToExportProfile && (
            <BqOption value='ExportProfile' onBqClick={toggleExportModalOpen}>
              <BqIcon slot='prefix' name='download-simple' />
              <span>{Text.ExportProfile}</span>
            </BqOption>
          )}
          <BqOption value='CopyProfileUrl' onBqClick={copyUserUrlHandler} data-testid='actions-column-copy-option'>
            <BqIcon slot='prefix' name='copy-simple' />
            <span>{Text.CopyProfileUrl}</span>
          </BqOption>
          {isAllowedToViewProfile && (
            <Link to={`/view/${userFullname}`} target='_blank'>
              <BqOption value='ViewUserProfile' data-testid='actions-column-view-option'>
                <BqIcon slot='prefix' name='eye' />
                {Text.ViewUserProfile}
              </BqOption>
            </Link>
          )}
          {isAllowedToDeleteViewProfile && (
            <BqOption
              value='DeleteUserProfile'
              onBqClick={toggleDeleteModalOpen}
              data-testid='actions-column-delete-option'>
              <BqIcon slot='prefix' name='trash' />
              <span>{Text.DeleteUserProfile}</span>
            </BqOption>
          )}
        </React.Fragment>
      </ActionsMenu>
      {isOpenExportModal && (
        <ExportProfile
          isOpenByChildren={isOpenExportModal}
          counter={1}
          profilesToExport={{ selectedUsersToExport: [userEmail], exportAllUsersExceptOf: [], filters: {} }}
          setIsLoading={setIsLoading}
          setLoadingText={setLoadingText}
          isOpenExternal={isOpenExportModal}
          setIsOpenExternal={setIsOpenExportModal}
        />
      )}

      {isOpenDeleteModal && (
        <ConfirmProfileDeletionDialog
          userEmail={userEmail}
          isOpenDeleteModal={isOpenDeleteModal}
          toggleDeleteModalOpen={toggleDeleteModalOpen}
          setIsLoading={setIsLoading}
          getProfiles={getProfiles}
          filtersToRequest={filtersToRequest}
          advancedSearchFilterData={advancedSearchFilterData}
        />
      )}
    </>
  )
}

ActionsCell.propTypes = {
  userEmail: PropTypes.string.isRequired,
  setIsLoading: PropTypes.func,
  setLoadingText: PropTypes.func,
  getProfiles: PropTypes.func,
  filtersToRequest: PropTypes.func,
  advancedSearchFilterData: PropTypes.object
}
